import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"
import { cn } from "../../lib/utils"

const iconBoxVariants = cva(
  "flex items-center justify-center flex-shrink-0",
  {
    variants: {
      variant: {
        light: "bg-purple-50 text-purple-600",
        dark: "bg-purple-500/20 text-purple-400",
        accent: "bg-purple-600 text-white",
      },
      size: {
        sm: "w-8 h-8 rounded-lg",
        default: "w-10 h-10 rounded-xl",
        lg: "w-12 h-12 rounded-xl",
        xl: "w-14 h-14 rounded-2xl",
      },
    },
    defaultVariants: {
      variant: "light",
      size: "default",
    },
  }
)

export interface IconBoxProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof iconBoxVariants> {}

const IconBox = React.forwardRef<HTMLDivElement, IconBoxProps>(
  ({ className, variant, size, ...props }, ref) => (
    <div ref={ref} className={cn(iconBoxVariants({ variant, size, className }))} {...props} />
  )
)
IconBox.displayName = "IconBox"

export { IconBox, iconBoxVariants }
